export default __webpack_public_path__ + "static/media/question-board.115a2637.png";